/**
 * Error403 — Branded 403 Forbidden page (#2454)
 *
 * No ConfigProvider / AuthProvider / BrandProvider dependency.
 */

import { PAGE_CSS, Logo, ErrorCard } from "./shared";

export function Error403() {
  return (
    <>
      <style>{PAGE_CSS}</style>
      <div className="err-page">
        <ErrorCard
          code="403"
          title="Access denied"
          message="You don't have permission to view this page. Sign in with an authorised account or contact your hive owner."
          accentVar="--brand-status-warning"
          accentBg="var(--brand-status-warning-bg)"
          accentBorder="rgba(232,140,0,0.25)"
        >
          <Logo />
        </ErrorCard>
      </div>
    </>
  );
}
